<template>
  <v-footer class="pb-6">
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between>
      <v-flex class="d-block layout row d-md-flex align-center justify-start pl-4 pl-md-0">
        <small class="d-block mb-2 mb-md-0">{{ $t("footer.right") }} -</small>
        <v-img
          class="img mb-5 mb-md-0"
          contain
          :src="`${require('@/assets/images/logo/'+bee)}`"
          max-width="200"
        ></v-img>
      </v-flex>
      <v-img
        class="img"
        contain
        :src="`${require('@/assets/images/logo/'+brps)}`"
        max-width="300"
      ></v-img>
    </v-layout>
  </v-footer>
</template>


<script>
export default {
  computed: {
    bee () {
      return this.$i18n.locale === 'nl' ? 'BEE-NL.png' :
             this.$i18n.locale === 'fr' ? 'BEE-FR.png' :
             this.$i18n.locale === 'en' ? 'BEE-EN.png' : 'BEE-EN.png'
    },
    brps () {
      return this.$i18n.locale === 'nl' ? 'BRPS-NL.png' :
             this.$i18n.locale === 'fr' ? 'BRPS-FR.png' :
             this.$i18n.locale === 'en' ? 'BRPS-EN.png' : 'BRPS-EN.png'
    }
  }
}
</script>

<style lang="css" scoped>
.img { border-radius: 0 !important; }
</style>
